(function () {
    'use strict';

    angular
        .module('partners')
        .controller('PartnerDashboardRegisteredModalController', PartnerDashboardRegisteredModalController)

    PartnerDashboardRegisteredModalController.$inject = ['$uibModalInstance', 'partner'];

    function PartnerDashboardRegisteredModalController($uibModalInstance, partner) {
        var vm = this;

        vm.ok      = ok;
        vm.cancel  = cancel;
        vm.partner = partner;

        activate();


        function activate() {
        }


        function ok () {
            $uibModalInstance.close();
        }


        function cancel () {
            $uibModalInstance.close();
        }

    }

})();